import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 34,
  height: 34,
}

const Sauna = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 34.75 34.75'
  >
    <g fill={color} transform='translate(-10.83 -10.83)'>
      <path
        d='M45.009,60.575H41.82a2.381,2.381,0,0,0-2.267-1.663h-4.5A2.236,2.236,0,0,0,32.9,60.575H11.4a.572.572,0,0,0-.572.572v3.1a.572.572,0,0,0,.572.572h.5V77.378a.572.572,0,0,0,.572.572H43.931a.572.572,0,0,0,.572-.572V64.823h.505a.572.572,0,0,0,.572-.572v-3.1A.572.572,0,0,0,45.009,60.575Zm-.572,3.1H41.93V61.718h2.507Zm-3.65,4.3H36.13V67.11h4.657Zm0-6.7v4.678H36.13V60.056h3.424a1.235,1.235,0,0,1,1.233,1.233Zm-5.8-1.226v.512h-.855a1.086,1.086,0,0,1,.855-.512ZM11.974,61.718H34.986v1.961H11.974Zm4.049,5.5h4.8v1.248h-4.8Zm1.829-2.391V66.07h-4.8V64.823Zm13.333,9.592V73.167h4.8v1.248Zm1.83,1.144v1.248h-4.8V75.558Zm10.346,1.248h-9.2V75.558h2.4a.572.572,0,0,0,.572-.572V72.6a.572.572,0,0,0-.572-.572H30.613a.572.572,0,0,0-.572.572v1.82h-2.4a.572.572,0,0,0-.572.572v1.82H13.049V67.214h1.83v1.82a.572.572,0,0,0,.572.572H21.4a.572.572,0,0,0,.572-.572V66.642a.572.572,0,0,0-.572-.572H19V64.823h15.99v3.733a.572.572,0,0,0,.572.572h.429v1.414a.572.572,0,0,0,1.144,0V69.128h.756v1.414a.572.572,0,1,0,1.144,0V69.128h.756v1.414a.572.572,0,1,0,1.144,0V69.128h.429a.572.572,0,0,0,.572-.572V64.823h1.43Z'
        transform='translate(0 -32.37)'
      />
      <path
        d='M37.9,13.473h7.571v.546a3.924,3.924,0,0,0-3.35,3.875.572.572,0,0,0,.572.572h6.7a.572.572,0,0,0,.572-.572,3.924,3.924,0,0,0-3.35-3.875v-.546H54.19a.572.572,0,0,0,.572-.572V11.4a.572.572,0,0,0-.572-.572H37.9a.572.572,0,0,0-.572.572v1.5A.572.572,0,0,0,37.9,13.473Zm10.861,3.849H43.329a2.778,2.778,0,0,1,5.437,0ZM38.477,11.974H53.618v.355H38.477Z'
        transform='translate(-17.842)'
      />
      <path
        d='M63.394,36.572a.572.572,0,1,0-1.144,0v1.334a.572.572,0,1,0,1.144,0Z'
        transform='translate(-34.617 -16.945)'
      />
      <path
        d='M53.167,36.572v1.334a.572.572,0,1,0,1.144,0V36.572a.572.572,0,1,0-1.144,0Z'
        transform='translate(-28.502 -16.945)'
      />
      <path
        d='M66.792,46.4v1.334a.572.572,0,1,0,1.144,0V46.4a.572.572,0,1,0-1.144,0Z'
        transform='translate(-37.675 -23.565)'
      />
      <path
        d='M57.708,46.4v1.334a.572.572,0,1,0,1.144,0V46.4a.572.572,0,1,0-1.144,0Z'
        transform='translate(-31.559 -23.565)'
      />
      <path
        d='M71.333,36.572v1.334a.572.572,0,1,0,1.144,0V36.572a.572.572,0,1,0-1.144,0Z'
        transform='translate(-40.732 -16.945)'
      />
      <path
        d='M62.822,54.917a.572.572,0,0,0-.572.572v1.334a.572.572,0,1,0,1.144,0V55.489A.572.572,0,0,0,62.822,54.917Z'
        transform='translate(-34.617 -29.68)'
      />
      <path
        d='M23.817,36.284a.572.572,0,1,0,.646.944c1.329-.909,1.484-2.056.519-3.835a1.541,1.541,0,0,1-.229-1.137.866.866,0,0,1,.437-.461.572.572,0,1,0-.42-1.064,1.993,1.993,0,0,0-1.088,1.121,2.5,2.5,0,0,0,.292,2.086C24.861,35.569,24.354,35.916,23.817,36.284Z'
        transform='translate(-8.574 -13.37)'
      />
      <path
        d='M32.927,36.284a.572.572,0,1,0,.646.944c1.329-.909,1.484-2.056.519-3.835a1.542,1.542,0,0,1-.229-1.137.866.866,0,0,1,.437-.461.572.572,0,1,0-.42-1.064,1.993,1.993,0,0,0-1.088,1.121,2.5,2.5,0,0,0,.292,2.086C33.971,35.569,33.464,35.916,32.927,36.284Z'
        transform='translate(-14.707 -13.37)'
      />
      <path
        d='M89.505,33.936c.885,1.632.377,1.979-.16,2.346a.572.572,0,1,0,.646.944c1.329-.909,1.484-2.056.519-3.835a1.542,1.542,0,0,1-.229-1.137.866.866,0,0,1,.437-.461.572.572,0,1,0-.42-1.064,1.993,1.993,0,0,0-1.088,1.121A2.5,2.5,0,0,0,89.505,33.936Z'
        transform='translate(-52.689 -13.37)'
      />
      <path
        d='M98.455,36.283a.572.572,0,1,0,.646.944c1.329-.909,1.484-2.056.519-3.835a1.542,1.542,0,0,1-.229-1.137.866.866,0,0,1,.438-.461.572.572,0,0,0-.42-1.064,1.993,1.993,0,0,0-1.088,1.121,2.5,2.5,0,0,0,.292,2.086C99.5,35.569,98.992,35.915,98.455,36.283Z'
        transform='translate(-58.822 -13.37)'
      />
    </g>
  </svg>
)

export default Sauna
